/* eslint no-undef: 0 */

export const WEBSITE_HOST = window.location.protocol + '//' + window.location.hostname
export const WEBSITE_PORT = window.location.port !== 80 ? ':' + window.location.port : window.location.port

export const DEFAULT_LANG = 'en'
export const HTML_DIVIDER = ' - '
export const PARAMS_DIVIDER = ' | '
export const TITLE_DIVIDER = ' / '

export const TITLE_ACTIONS = 'Actions'
export const TITLE_ADD = 'Add'
export const TITLE_ADD_PLATFORM = 'Add platform'
export const TITLE_ARCHIVE_BUTTON = 'See changes'
export const TITLE_BATCH_ACTIONS = 'Batch actions'
export const TITLE_CANCEL = 'Close'
export const TITLE_CREATE = 'Create new'
export const TITLE_DELETE = 'Delete'
export const TITLE_DETAIL = 'Detail'
export const TITLE_EDIT = 'Edit'
export const TITLE_FINISHED = 'Finished'
export const TITLE_INSERT_OVERWRITE_N = 'Insert and NOT overwrite'
export const TITLE_INSERT_OVERWRITE_Y = 'Insert and overwrite'
export const TITLE_LIST = 'List'
export const TITLE_NEWER = 'Newer'
export const TITLE_NEXT = 'Next'
export const TITLE_OLDER = 'Older'
export const TITLE_PREVIOUS = 'Previous'
export const TITLE_REMOVE = 'Remove'
export const TITLE_RESTORE = 'Restore'
export const TITLE_RETURN = 'Return'
export const TITLE_RUNNING = 'Running'
export const TITLE_SAVE = 'Save'
export const TITLE_SAVE_RETURN = 'Save and exit'
export const TITLE_SOLVED = 'Solved'
export const TITLE_SUBMIT = 'Submit'
export const TITLE_UPLOAD = 'Upload'
export const TITLE_VIEW = 'View'

export const STATUS_ERROR = 'error'
export const STATUS_EVERYTHING_UP_TO_DATE = 'everything is up to date'
export const STATUS_FETCH_OR_SAVE_ERROR = 'fetch/save error'
export const STATUS_ARCHIVING_ERROR = 'archiving error'
export const STATUS_NO_MERGEABLE = 'not mergeable'
export const STATUS_PAST_TIME_RESTRICTION = 'Item is time restricted'
export const STATUS_SAVED = 'saved'
export const STATUS_SELECTED = 'selected'
export const STATUS_UNDEFINED = 'undefined'
export const STATUS_UPDATED = 'updated'
export const STATUS_UPDATING = 'updating'
export const STATUS_VALIDATION_FAIL = 'validation failed'
export const STATUS_WARNING_IMBD = 'warning - no IMDB ID'

export const UPLOAD_IMAGE_FOLDER = 'artwork'
export const UPLOAD_IMAGE_POSTFIX = 'jpg'
export const UPLOAD_MAXPREVIEWSIZE = 10000000 // 10M
export const UPLOAD_PLATFORM = 'flyprivate'
export const UPLOAD_SUBTITLES_POSTFIX = 'vtt'
export const UPLOAD_SUBTITLES_TEST_STRING = 'WEBVTT'
export const UPLOAD_TOOBIGIMAGE = 'https://i.ytimg.com/vi/LIhk7T9FJWg/hqdefault.jpg' // trololo :)
export const UPLOAD_VIDEO_FOLDER = 'video'
export const UPLOAD_VIDEO_POSTFIX = 'mp4'

export const UPLOAD_ARTWORKS_FILENAME = 'https://flyprivate-artwork-prd.s3.amazonaws.com/artwork/'
export const UPLOAD_ARTWORKS_SMALL = {
  'carousel-178': '_384x216.jpg',
  'carousel-235': '_900x383.jpg',
  player: '_320x180.jpg',
  poster: '_150x225.jpg'
}
export const UPLOAD_ARTWORKS_FULL = {
  'carousel-178': '_1920x1080.jpg',
  'carousel-235': '_2538x1080.jpg',
  player: '_1920x1080.jpg',
  poster: '_1000x1500.jpg'
}
export const VIDEO_QUALITY = {
  'quality_mobile': 'mobile quality',
  'quality_sd': 'SD quality',
  'quality_hd': 'HD quality',
  'quality_uhd': 'UHD quality'
}

// don't change order of VIDEO_TYPES & SUBTITLES_TYPES
export const VIDEO_TYPES = ['preview', 'feature']
export const SUBTITLES_TYPES = ['subtitles-preview', 'subtitles-feature']
export const PPROLLS_TYPES = ['pprolls']

// list of all pprolls condition tables: 'platforms','categories','homepage','tiers','pricings','film'
export const PPROLLS_HIDDEN_OPTIONS = ['homepage', 'pricings', 'film']

export const ACTION_BUTTON_CLASS1 = 'btn btn-success'
export const ACTION_BUTTON_CLASS2 = 'btn btn-danger'

export const DATE_FORMAT = 'yyyy-MM-DD'
export const DATE_FORMAT_FULL = 'yyyy-MM-DD HH:mm:ss'
export const DATE_GMT_TZ = 'Etc/GMT'
export const DATE_LANGUAGE = 'en-gb'
export const DATE_MAX_DATE = '2100-12-31'
export const DATE_MIN_YEAR = 1990
export const DATE_MAX_YEAR = 2100
export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm'
export const DATE_TIME_FORMAT_FULL = 'yyyy-MM-dd HH:mm:ss'
export const DATE_TIME_ONLY = 'HH:mm:ss'
export const DATE_TIME_UTC = 'T00:00:00.000Z'
export const DATE_TIME_UTC_END = 'T23:59:59.000Z'
export const DATE_VALID_TO_TIME = [23, 59, 59]

export const LATEST_VERSION = [Conf.version, `(${Conf.timestamp})`]
export const AUTH0_TEST_INTERVAL = 30 // min.
export const LATEST_VERSION_TEST_INTERVAL = 10 // min.
export const UPDATE_OPTIONS_INTERVAL = 10 // min.
export const ETL_RUNNER_INTERVAL = 2 // min.

export const FLYPRIVATE_TESTING_FILMS_LIMIT = 1200

export const CORS_PROXY_SERVERS = Conf.corsProxyServers || []

export const TEMPLATE_SKIN_KEY = 'cargo_v2_skin'

export const PPROLLS_REPORT_ID = 70
export const PPROLLS_REQUEST = '/reporting/load/' + PPROLLS_REPORT_ID
export const PPROLLS_PARAMETER = '149_param'
export const BLUESKY_CONTRACTOR_IDS = [3, 30, 113]

export const MAIN_QUERY_PARAMETERS = ['_page', '_perPage', '_allPages']
export const SLUG_REPLACE = {
  from: /ã|ñ/gi,
  to: (letter) => {
    switch (letter) {
    case 'ã': return 'a'
    case 'ñ': return 'n'
    }
  }
}

export const PLATFORMS_DEFAULT_VALUE = '---'
export const PLATFORMS_NAMES = {
  FP: 'flyprivate',
  flyprivate: 'FP',
  GP: 'googleplay',
  googleplay: 'GP',
  iT: 'itunes',
  itunes: 'iT',
  YT: 'youtube',
  youtube: 'YT',
  UPC: 'upc',
  upc: 'UPC',
  // 'VM': 'vimeo',
  // 'vimeo': 'VM',
  AM: 'amazon',
  amazon: 'AM',
  MIC: 'microsoft',
  microsoft: 'MIC'
}

export const ENTNAMES = {
  ARCHIVE: 'archive',
  CLIENTS: 'clients',
  CONTRACTITEMS: 'contractitems',
  CONTRACTS: 'contracts',
  CONTRACT_TIME_RESTRICTIONS: 'contract_time_restrictions',
  ENUMS: 'enums',
  ETL_RUNNER: 'etl_runner',
  FILMCARGO_HELP: 'filmcargo_help',
  FILMS: 'films',
  FINANCIAL_REPORTS: 'financial_reports',
  FP_CATEGORIES: 'flyprivate_categories_settings',
  FP_HOMESETT: 'flyprivate_homepage_settings',
  FP_PRICING: 'flyprivate_pricing',
  FP_TESTING: 'flyprivate_testing',
  PERSONS: 'persons',
  PPROLLS: 'pprolls',
  PPROLLS_UPLOAD: 'pprolls_upload',
  PUBLISH: 'publish',
  RATING: 'rating',
  REPORTS: 'reports',
  RIGHTS: 'rights',
  SHOWREPORTS: 'showreports',
  VATRATES: 'vatrates',
  XRATES: 'xrates',
  YOUTUBE_ASSETS: 'youtube_assets'
}

export const UPLOAD_INTERVAL_SEC = 10 // sec.
export const UPLOAD_TIMEOUT_MIN = 5 // min.
export const UPLOAD_FILE_MISSING = 'file missing'
export const STATES_UPLOAD = {
  UPLOADING: 'uploading',
  WAITING: 'waiting',
  CANCELLED: 'canceled',
  FAILED: 'failed'
}
export const STATES_UNFINISHED = [
  STATES_UPLOAD.UPLOADING,
  STATES_UPLOAD.WAITING,
  STATES_UPLOAD.CANCELLED,
  STATES_UPLOAD.FAILED
]

export const IMAGE_RESOLUTIONS = {
  brick: [16, 9],
  'carousel-178': [1.78, 1],
  'carousel-235': [2.35, 1],
  player: [16, 9],
  poster: [2, 3]
}
